module.exports = __webpack_public_path__ + "img/bg-whats-covered.9acbe04a.jpg";